import { Skeleton } from "@/shared/components/ui/skeleton";
import { Card } from "@/shared/components/ui/card";

const mockData = [
  {
    label: "Tersine Müh.",
    value: 973,
    percentage: 48.6,
    color: "#f3f4f6",
  },
  {
    label: "Yapay Zeka",
    value: 686,
    percentage: 34.3,
    color: "#f3f4f6",
  },
  {
    label: "Şablonlar",
    value: 383,
    percentage: 19.1,
    color: "#f3f4f6",
  },
  {
    label: "İçe aktarım",
    value: 172,
    percentage: 8.6,
    color: "#f3f4f6",
  },
  {
    label: "Manuel",
    value: 45,
    percentage: 2.3,
    color: "#f3f4f6",
  },
]

export default function AverageTimeCardLoadingState() {
  return (
    <Card className="w-full border border-[#e5e5e5] bg-white rounded-[16px] shadow-[0px_1px_2px_0px_rgba(10,13,20,0.03)]">
      <div className="border-b border-[#e4e4e7] h-[50px] flex items-center px-[20px] py-[16px]">
        <div className="flex items-start flex-1 h-full">
          <p className="text-[16px] font-[700] text-[#000000] leading-[24px]">
            Tedariğe Hazır Olma Süresi
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-[20px] items-start pb-[20px] pt-0 px-[20px] w-full">
        <div className="flex flex-col items-start justify-center w-full">
          <div className="flex gap-[0px] items-start w-full">
            <div className="flex flex-col gap-[4px] items-start mt-[20px]">

              <Skeleton className="h-4 w-[180px] rounded mt-[12px]" />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[0px] items-start w-full">
          <div className="flex gap-[2px] items-start w-full">
            <div className="flex gap-[2px] items-start w-full">
              <Skeleton className="h-4 w-[100px] rounded" />
              <Skeleton className="h-4 w-[100px] rounded" />
              <Skeleton className="h-4 w-[100px] rounded" />
              <Skeleton className="h-4 w-[100px] rounded" />
              <Skeleton className="h-4 w-[100px] rounded" />
            </div>
          </div>
        </div>
        <hr className="w-full border-[#e4e4e7]" />
        <div className="flex flex-col gap-[18px] items-start w-full pb-[14px]">
          <div className="flex gap-[20px] w-full">
            <div className="text-[#bdb8b8] text-[12px] font-700 flex-1">
              Kaynak
            </div>
            <div className="text-[#bdb8b8] text-[12px] font-700 w-[70px] text-center">
              Yüzde
            </div>
            <div className="text-[#bdb8b8] text-[12px] font-700 w-[70px] text-right">
              Toplam
            </div>
          </div>
          {mockData.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between w-full"
            >
              <div className="flex gap-[6px] items-center flex-1 min-w-0">
                <div
                  className="border-[2px] border-white rounded-full shadow-[0px_2px_4px_0px_rgba(27,28,29,0.04)] size-[12px] shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <div className="text-[14px] font-[600] text-[rgba(63,63,70,0.7)] leading-[20px] tracking-[-0.3px] truncate">
                  <Skeleton className="h-4 w-[100px] rounded" />
                </div>
              </div>
              <div className="font-[Inter] text-[14px] font-[500] w-[70px] text-[#A1A1AA] leading-[20px] tracking-[-0.084px]">
                <Skeleton className="h-4 w-[30px] rounded" />
              </div>
              <div className="text-[14px] font-[700] w-[70px] text-right text-[rgba(63,63,70,0.8)] leading-[20px] shrink-0">
                <Skeleton className="h-4 ml-auto w-[30px] rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}